<mat-checkbox [formControl]="formControlRef"
  [class.large]="size === 'large'"
  [color]="color"
  [tabIndex]="tabIndex"
  [required]="required"
  (change)="change.emit($event.checked)">
  <ng-content></ng-content>
</mat-checkbox>
